export default __webpack_public_path__ + "static/media/img-0593-poland-half-face.fad7b999.png";